import React, { FC } from 'react'
import styled from 'styled-components'

import { box, flexCenterChildren, imageLoadingCircle } from '@Globals/Style/mixins'

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  ${box({ width: '100%' })}
  ${flexCenterChildren}
  &:after {
    ${imageLoadingCircle({ borderWidth: '3px', size: '60px' })}
    margin-top: -10px;
  }
`

export const Loading: FC = () => (
  <Wrapper />
)
